// @flow

import {createSelector} from 'reselect';
import {addGIDToProceduresHTMLURL} from './selectors';

import * as utils from 'app/procedures/utils';

import type {
  ProcessVersionType,
  ProcessContentType,
  ProcessType,
} from 'app/process/types';

export const processOrVersionToContent = createSelector<
  ProcessVersionType,
  ProcessType,
  ProcessContentType,
  ProcessVersionType,
  ProcessType
>(
  (version) => version,
  (version, process) => process,
  (version, process) => {
    const object = version != null ? version : process;

    return addGIDToProceduresHTMLURL(
      {
        url: object.url,
        html_url: object.html_url,
        name: object.name,
        description: utils.getDescription(object),
        content: object.content,
        lanes: object.lanes,
      },
      process
    );
  }
);
